export function toLocalISODate(value: Date | number | string): string {
  const date = value instanceof Date ? value : new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayLocalISO(): string {
  return toLocalISODate(new Date());
}

export function addLocalDaysISO(days: number, from: Date | number | string = new Date()): string {
  const base = from instanceof Date ? from : new Date(from);
  const next = new Date(base.getFullYear(), base.getMonth(), base.getDate() + days);
  return toLocalISODate(next);
}
